import { initGraphQLTada } from "gql.tada";

import type { introspection } from "./graphql-env";

export const graphql = initGraphQLTada<{
  introspection: introspection;
  scalars: {
    ISO8601DateTime: string;
    ISO8601Date: string;
  };
}>();

export type { FragmentOf, ResultOf, VariablesOf } from "gql.tada";
export { maskFragments, readFragment, unsafe_readResult } from "gql.tada";
